import { Merchant, MerchantContract } from '@nemuru-eng/js-api-client';
import React, { Dispatch, SetStateAction } from 'react';

import { MerchantContractActionType } from '../../types/MerchantContractActionType';
import { MerchantContractDialog } from './components/MerchantContractDialog';
import { MerchantContractRelatedActionsDialog } from './components/MerchantContractRelatedActionsDialog';

export const MerchantContractActionsDialog = ({
  merchantContractAction,
  merchantContract,
  merchantContractFromCrm,
  merchant,
  opened,
  setOpened,
  toggleDialog,
}: {
  merchantContractAction: MerchantContractActionType;
  merchantContract?: MerchantContract;
  merchantContractFromCrm?: MerchantContract;
  merchant: Merchant;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog: () => void;
}) => {
  return (
    <>
      {merchantContractAction === MerchantContractActionType.SEE_MERCHANT_CONTRACT_FIELDS && merchantContract && (
        <MerchantContractDialog
          merchantContractAction={merchantContractAction}
          opened={opened}
          setOpened={setOpened}
          toggleDialog={toggleDialog}
          merchant={merchant}
          merchantContract={merchantContract}
        />
      )}
      {merchantContractAction === MerchantContractActionType.SEE_MERCHANT_CONTRACT_FIELDS_FROM_CRM &&
        merchantContractFromCrm && (
          <MerchantContractDialog
            merchantContractAction={merchantContractAction}
            opened={opened}
            setOpened={setOpened}
            toggleDialog={toggleDialog}
            merchant={merchant}
            merchantContract={merchantContractFromCrm}
          />
        )}
      {(merchantContractAction === MerchantContractActionType.SEND_MERCHANT_CONTRACT_REMINDER ||
        merchantContractAction === MerchantContractActionType.SEND_NEW_MERCHANT_CONTRACT) && (
        <MerchantContractRelatedActionsDialog
          merchantContractAction={merchantContractAction}
          opened={opened}
          setOpened={setOpened}
          toggleDialog={toggleDialog}
          merchant={merchant}
        />
      )}
    </>
  );
};
